import { t } from 'i18next';

export default function ErrorMessage({ error, className = 'inputError', style, message }) {
	if (message) {
		return (
			<p className={className} style={style}>
				{message}
			</p>
		);
	} else if (error) {
		switch (error.type) {
			case 'required': {
				return (
					<p className={className} style={style}>
						{t('This is required')}
					</p>
				);
			}
			case 'minLength': {
				return (
					<p className={className} style={style}>
						{t('Minimum 50')}
					</p>
				);
			}
			case 'maxLength': {
				return (
					<p className={className} style={style}>
						{t('Exceeded Max characters')} ( 191 )
					</p>
				);
			}
			case 'pattern': {
				return (
					<p className={className} style={style}>
						{t('Value does not match required pattern')}
					</p>
				);
			}
			case 'emailAddress': {
				return (
					<p className={className} style={style}>
						{t('Enter a valid email address')}
					</p>
				);
			}
			case 'phoneNumber': {
				return (
					<p className={className} style={style}>
						{t('Enter a valid phone number')}
					</p>
				);
			}
			case 'min': {
				return (
					<p className={className} style={style}>
						{t('Minmium of')}{' '}
					</p>
				);
			}
			case 'max': {
				return (
					<p className={className} style={style}>
						{t('Max of')}{' '}
					</p>
				);
			}
			case 'validate': {
				return (
					<p className={className} style={style}>
						{t('Value is invalid')}
					</p>
				);
			}
			case 'minLength10': {
				return (
					<p className={className} style={style}>
						{t('Enter a minimum of 10 characters')}
					</p>
				);
			}
			case 'noMatch': {
				return (
					<p className={className} style={style}>
						{t('Does not match')}
					</p>
				);
			}
			case 'addressRequired': {
				return (
					<p className={className} style={style}>
						{t('This is required')}. {t('Drop a pin or search for a location')}.
					</p>
				);
			}
			case 'missionArea':
			case 'intersect': {
				return (
					<p className={className} style={style}>
						{t('The area can not intersect itself')}. {t('Please adjust the drawing on the map')}.
					</p>
				);
			}
			case 'roleRequired': {
				return (
					<p className={className} style={style}>
						{t('Role is required')}
					</p>
				);
			}
			case 'nameRequired': {
				return (
					<p className={className} style={style}>
						{t('Crew member name is required')}
					</p>
				);
			}
			case 'flightDuration': {
				return (
					<p className={className} style={style}>
						{t('Flight duration must be greater than 0')}
					</p>
				);
			}
			case 'passwordMismatch': {
				return (
					<p className={className} style={style}>
						{t('Passwords must match')}.
					</p>
				);
			}
			case 'passwordShape': {
				return (
					<p className={className} style={style}>
						{t(
							'Password must be at least 8 characters in length and contain at least 1 lowercase letter, 1 uppercase letter, 1 number, and 1 special character'
						)}
						.
					</p>
				);
			}
			case 'sixDigitCode': {
				return (
					<p className={className} style={style}>
						{t('Code must be 6 digits long')}
					</p>
				);
			}
			case 'laancShapeValid': {
				return (
					<p className={className} style={style}>
						{t('The authorization area can not intersect itself')}.{' '}
						{t('Please adjust the drawing on the map')}.
					</p>
				);
			}
			case 'laancWithInDistance': {
				return (
					<p className={className} style={style}>
						{t('The flight area is too large')}.
					</p>
				);
			}
			case 'dates': {
				return (
					<p className={className} style={style}>
						{t('Start date must be before end date')}.
					</p>
				);
			}
			default: {
				return null;
			}
		}
	}

	return null;
}
